import angular from 'angular';
import wageAdvanceResumeComponent from './wageAdvanceResume.component';

let wageAdvanceResumeModule = angular.module('wageAdvanceResume', [
])

.component('wageAdvanceResume', wageAdvanceResumeComponent)

.name;

export default wageAdvanceResumeModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceResume/wageAdvanceResume.js